import { CalendarWeekBeginOutlineIcon } from './CalendarWeekBeginOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 420E6A80-6C58-48A6-A8A8-8119D53633D7
 * name calendar-week-begin-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-week-begin-outline.svg
 * tags
 * - Date / Time 
 */
export const EventWeekBeginOutlineIcon = CalendarWeekBeginOutlineIcon;
export default EventWeekBeginOutlineIcon